// test1208
(1208 && 0);
